import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	addPrioritiesToggle: {
		id: 'admin-pages-priority-schemes.common.priority-picker.add-priorities-toggle',
		defaultMessage: 'Add priorities',
		description: 'Priority picker toggle button text',
	},
	loadMore: {
		id: 'admin-pages-priority-schemes.common.priority-picker.load-more',
		defaultMessage: 'Load more',
		description: 'Load more button text',
	},
	clearSelection: {
		id: 'admin-pages-priority-schemes.common.priority-picker.clear-selection',
		defaultMessage: 'Clear selection',
		description: 'Label for the button to clear selected priorities in the list',
	},
	noMatchingPriorities: {
		id: 'admin-pages-priority-schemes.common.priority-picker.no-matching-priorities',
		defaultMessage: 'No matching priorities',
		description: 'Message displayed when no priorities match the search criteria',
	},
	noPriorities: {
		id: 'admin-pages-priority-schemes.common.priority-picker.no-priorities',
		defaultMessage: 'No available priorities',
		description: 'Message displayed when there are no available priorities to choose from',
	},
	prioritiesCountInfo: {
		id: 'admin-pages-priority-schemes.common.priority-picker.priorities-count-info',
		defaultMessage:
			'{dispayedCount} of {totalCount, plural, one {# priority} other {# priorities}}',
		description: 'Information about how many priorities are displayed and how many are in total',
	},
	searchFieldPlaceholder: {
		id: 'admin-pages-priority-schemes.common.priority-picker.search-field-placeholder',
		defaultMessage: 'Search priorities',
		description: 'Placeholder text for the search field in the priority picker',
	},
});

export default messages;
